import { useQuery } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { getFamilyLedgerDetail } from './api';
import { familyLedgerDetailKey } from './key';
export type { GetFamilyLedgerDetailResponse } from './type';
export function prefetchFamilyLedgerDetail(personId: string, familyPersonId: string) {
  return queryClient.ensureQueryData({
    queryKey: familyLedgerDetailKey.detail(personId, familyPersonId),
    queryFn: () => getFamilyLedgerDetail(personId, familyPersonId),
    staleTime: 5 * 60 * 1000
  });
}
export function useGetFamilyLedgerDetail(personId: string, familyPersonId: string) {
  return useQuery({
    queryKey: familyLedgerDetailKey.detail(personId, familyPersonId),
    queryFn: () => getFamilyLedgerDetail(personId, familyPersonId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  });
}